import loading from '../assets/loading.svg';

const Loading = () => (
  <div className="fixed h-full bg-black bg-opacity-80 w-full z-50 top-0 left-0" data-testid="loading-spinner">
    <img className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2' src={loading} alt="Loading" />
  </div>
);

export default Loading;
